import React from 'react'
import { Container, Typography, Box} from "@mui/material"
import invSimulator from '../Assets/invSimulator.mp4'
import tsForecast from '../Assets/tsForecast.mp4'
// import proceMonitoring from '../Assets/proceMonitoring.mp4'
import ReactPlayer from 'react-player'

const Products = () => {
  return (
    <Container id = 'products' sx={{paddingTop: '5rem', paddingBottom: '3rem'}}>
       <Typography sx={{fontSize: '3rem', textAlign: 'center', marginBottom: '2rem', marginTop: '2rem',
                        '@media (max-with: 442px)': {fontSize: '1.5rem'}}}> 
            Featured Products
       </Typography>
       <Typography sx={{fontSize: '1.2rem', marginBottom: '1rem', textAlign: 'center'}}>
            In this section you will find highlights of some Applications and Ideas by area of Value Proposition. "We just don't talk about our capabilities ... we demonstrate our capabilities". Contact us for Applications demonstrations and and also with any inquiries.

       </Typography>

       <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', 
                 width: '100%', textAlign: 'center', gap: '4rem', marginBottom: '2rem'}}>

          <Box sx={{transition: '0.3s', '&:hover':{transform: 'scale(1.05)'}, justifyContent: 'center'}}>
            <ReactPlayer url = {tsForecast} controls = {true} height = '12rem' width = '18rem'/>
            <Typography sx={{fontSize: '1.0rem', width: '15rem', textAlign: 'left'}}> Time Series Forecasting e.g. for demand and sales 
            </ Typography>
            <Typography sx={{backgroundColor: '#064760 ', color: 'white', fontSize: '1.1rem', fontWeight : 'bold', width: '18rem'}}> Predictive Analytics 
            </ Typography>
 
          </Box>   

          <Box sx={{transition: '0.3s', '&:hover':{transform: 'scale(1.05)'}}}>
            <ReactPlayer url = {invSimulator} controls = {true} height = '12rem' width = '18rem'/>
            <Typography sx={{fontSize: '1.0rem', width: '15rem', textAlign: 'left'}}> Inventory Simulation. The customer centric approach
            </Typography>
            <Typography sx={{backgroundColor: '#064760 ', color: 'white', fontSize: '1.1rem', fontWeight : 'bold', width: '18rem'}}> Scenario Simulations 
            </ Typography>

          </Box>  

{/*           <Box sx={{transition: '0.3s', '&:hover':{transform: 'scale(1.05)'}}}>
            <ReactPlayer url = {proceMonitoring} controls = {true} height = '12rem' width = '18rem'/>
            <Typography sx={{fontSize: '1.0rem', width: '15rem', textAlign: 'left'}}> Monitoring of operations performance
            </Typography>
            <Typography sx={{backgroundColor: '#064760 ', color: 'white', fontSize: '1.1rem', fontWeight : 'bold', width: '18rem'}}> Performance Monitoring
            </ Typography>

          </Box>    */}            

       </Box>

    </Container>
  )
}

export default Products